<template>
  <div class="pos_container_panel" style="padding-left: 2rem; width: 90%">
    <Loading :loading="submitLoading" />
    <!--add area-->
    <el-form
      :inline="true"
      :model="searchForm"
      class="demo-form-inline"
      style="margin-left: 6rem; padding-top: 2rem"
    >
      <el-row style="">
        <el-col :span="24">
          <div class="grid-content bg-purple search-fields">
            <el-form-item label="渠道" class="search-form-item search-form-item-source">
              <el-select v-model="searchForm.source" class="search-select search-select-source">
                <el-option value="">请选择</el-option>
                <el-option
                  v-for="item in sourceList"
                  :key="item.Type"
                  :label="item.Value"
                  :value="item.Type"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="酒店集团" class="search-form-item search-form-item-wide">
              <el-select v-model="searchForm.groupCode" class="search-select search-select-wide" filterable>
                <el-option value="">请选择</el-option>
                <el-option
                  v-for="item in groupList"
                  :key="item.code"
                  :label="item.cName"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="协议价格类型" class="search-form-item">
              <el-select v-model="searchForm.priceType" class="search-select">
                <el-option value="">请选择</el-option>
                <el-option
                  v-for="item in priceList"
                  :key="item.Type"
                  :label="item.Value"
                  :value="item.Type"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-light"></div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple-light">
            <el-button type="warning" class="harpIDbtn" @click="customSearch()">
              搜索</el-button
            >
            <el-button
              type="warning"
              class="harpIDbtn"
              style="margin-left: 3rem"
              @click="addHotelPoint()"
            >
              新增
            </el-button>
            <el-button
              type="warning"
              class="harpIDbtn"
              @click="uploadFile"
              style="margin-left: 3rem"
            >
              导入全部（批量替换）</el-button
            >
            <input
              type="file"
              @change="fileValueChange()"
              ref="uploadFile"
              enctype="multipart/form-data"
              id="import_btn"
              style="display: none"
              accept=".xls"
            />
            <el-button
              type="warning"
              class="harpIDbtn"
              @click="uploadFileAdd"
              style="margin-left: 3rem"
            >
              导入（新增）</el-button
            >
            <el-button
              type="warning"
              class="harpIDbtn"
              style="margin-left: 3rem"
              @click="PointsExport()"
            >
              导出
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <!--table-->
    <el-table
      :data="tableData"
      border
      style="width: 90%; margin-top: 50px; margin-left: 100px"
    >
      <el-table-column
        prop="source"
        label="渠道"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="groupid"
        label="酒店集团编码"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="groupid"
        label="酒店集团"
        align="center"
        :formatter="Format"
      ></el-table-column>
      <el-table-column
        prop="priceType"
        label="协议价格类型"
        align="center"
        :formatter="Format"
      ></el-table-column>
      <el-table-column
        prop="isEarnPoints"
        label="是否积分"
        align="center"
        :formatter="Format"
      ></el-table-column>
      <el-table-column
        prop="createdDate"
        label="创建时间"
        align="center"
        :formatter="Format"
      ></el-table-column>
      <el-table-column label="操作" width="132" align="center">
        <template #default="scope">
          <!-- <el-button @click="handleChange(scope.row)" type="text" size="small"
            >修改</el-button
          > -->
          <el-button
            type="text"
            size="small"
            @click.prevent="deleteRow(scope.row)"
            >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-bottom: 1rem">
      <el-pagination
        class="paginationsty"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        v-model:current-page="currentPage1"
        :page-size="15"
        layout="total, prev, pager, next"
        :total="searchForm.total"
      >
      </el-pagination>
    </div>
    <!--新增 dialog-->
    <el-dialog
      title="新增"
      v-model="dialogFormVisible"
      @close="closeaddDialog('form')"
    >
      <div v-draggable>
      <el-form :model="form" ref="form">
        <el-form-item
          label="渠道:"
          :label-width="formLabelWidth"
          prop="source"
          :rules="[
            {
              required: true,
              message: '请选择渠道',
              trigger: 'blur',
            },
          ]"
        >
          <el-select v-model="form.source">
            <el-option
              v-for="item in sourceList"
              :key="item.Type"
              :label="item.Value"
              :value="item.Type"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="酒店集团:"
          :label-width="formLabelWidth"
          prop="groupid"
          :rules="[
            {
              required: true,
              message: '请选择酒店集团',
              trigger: 'blur',
            },
          ]"
        >
          <el-select v-model="form.groupid" filterable>
            <el-option
              v-for="item in groupList"
              :key="item.code"
              :label="item.cName"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="适配协议价格:"
          :label-width="formLabelWidth"
          prop="priceType"
          :rules="[
            {
              required: true,
              message: '请选择适配协议价格',
              trigger: 'blur',
            },
          ]"
        >
          <el-select v-model="form.priceType">
            <el-option
              v-for="item in priceList"
              :key="item.Type"
              :label="item.Value"
              :value="item.Type"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="是否可积分:"
          :label-width="formLabelWidth"
          prop="isEarnPoints"
          :rules="[
            {
              required: true,
              message: '请选择是否可积分',
              trigger: 'blur',
            },
          ]"
        >
          <el-radio-group v-model="form.isEarnPoints">
            <el-radio label="true">是</el-radio>
            <el-radio label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="dataSave()">保存</el-button>
          <el-button @click="cancel('form')">取 消</el-button>
        </div>
      </template>
    </el-dialog>
    <!--删除 dialog-->
    <el-dialog
      title=""
      v-model="deletedialogVisible"
      width="30%"
    >
      <div v-draggable>
      <span>请确认是否删除</span>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="confirmDelete">确 定</el-button>
          <el-button @click="cancelDelete">取 消</el-button>
        </span>
      </template>
    </el-dialog>
    <ConfirmBoxs
      :centerDialogVisible="confirmFlag"
      :confirmMsg="confirmMsg"
      :icon="confirmIcon"
      @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
  </div>
</template>

<script>
import {
  getPointsList,
  SaveHotelPoint,
  PointsDelete,
  HotelPointsImport,
  groupList,
  PointsListExport,
} from "@/api/shoppingData";
import Loading from "@/components/Loading.vue";
import ConfirmBoxs from "@/components/confirmBoxs.vue";
import { formatDateTime, getFileName } from "@/utils/utils.js";
export default {
  name: "HBEPoints",
  components: {
    ConfirmBoxs,
    Loading,
  },
  data() {
    return {
      deletedialogVisible: false,
      deleteFlag: false,
      deleteparams: {},
      confirmFlag: false,
      changeRow: {},
      currentPage1: 1,
      //新增dialog
      confirmIcon: "",
      confirmMsg: "", // 弹框文案
      dialogFormVisible: false, //新增弹框
      formLabelWidth: "150px",
      tableData: [],
      searchForm: {
        source: "",
        groupCode: "",
        priceType: "",
        total: 0,
      }, //搜索查询model
      submitLoading: false,
      sourceList: [
        { Type: "sabre", Value: "sabre" },
        { Type: "sabre-oversea", Value: "sabre-oversea" },
        { Type: "booking", Value: "booking" },
        { Type: "booking-oversea", Value: "booking-oversea" },
        { Type: "elong", Value: "elong" },
        { Type: "atour", Value: "atour" },
        { Type: "wehotel", Value: "wehotel" },
        { Type: "huazhu", Value: "huazhu" },
        { Type: "homeinns", Value: "homeinns" },
        { Type: "dongchengv2", Value: "dongchengv2" },
        { Type: "fuxun", Value: "fuxun" },
        { Type: "CWTbur", Value: "CWTbur" },
      ], //渠道列表
      groupList: [], //渠道列表
      priceList: [
        { Type: "0", Value: "全部" },
        { Type: "1", Value: "公司协议价" },
        { Type: "2", Value: "酒店集团协议价" },
      ], //价格类型列表

      form: {
        id: 0,
        source: "",
        groupid: "",
        priceType: "",
        isEarnPoints: "true",
      },
      importType: "all", //添加方式
    };
  },
  mounted() {
    this.getGroupList();
  },
  methods: {
    closeaddDialog(formRule) {
      this.$refs[formRule].resetFields();
    },
    //分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.customSearch(val);
    },

    addHotelPoint() {
      this.dialogFormVisible = true;
    },
    //新增保存
    async dataSave() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let saveParams = {
            source: this.form.source,
            groupid: this.form.groupid,
            priceType: this.form.priceType,
            isEarnPoints: this.form.isEarnPoints,
          };
          SaveHotelPoint(saveParams)
            .then((res) => {
              if (res.code == 200) {
                if (!res.data.item1) {
                  this.confirmFlag = true;
                  this.deleteFlag = false;
                  this.confirmMsg = res.data.item2; //res.message
                  this.currentPage1 = 1;
                } else {
                  this.confirmFlag = true;
                  this.deleteFlag = false;
                  this.confirmMsg = "新增成功";
                  this.dialogFormVisible = false;
                  this.customSearch();
                  this.currentPage1 = 1;
                  this.form = {};
                }
              } else {
                this.confirmFlag = true;
                this.deleteFlag = false;
                this.confirmMsg = res.message; //res.message
                this.currentPage1 = 1;
              }
            })
            .catch(function (error) {
              console.log("新增失败", error.objError);
              this.customSearch();
            });

          // this.form = {};
        }
      });
    },
    //excel导出
    async PointsExport() {
      let saveParams = {
        groupId: this.searchForm.groupCode,
        source: this.searchForm.source,
        priceType: this.searchForm.priceType,
      };

      // 确保请求配置了 responseType: 'blob'
      PointsListExport(saveParams)
        .then((res) => {
          // 执行下载
          const downloadLink = document.createElement("a");
          // 设置下载文件名
          const fileName = getFileName();
          // .csv 文件后缀
          downloadLink.download = fileName + ".xls"; // 文件名称
          downloadLink.style.display = "none";
          //csv文件的type  text/csv    xls:application/vnd.ms-excel
          const blob = new Blob([res], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          }); //字节转成 Blob
          downloadLink.href = URL.createObjectURL(blob);
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        })
        .catch((error) => {
          console.log("导出Excel", error);
        });
    },
    //取消button
    cancel(formRule) {
      this.$refs[formRule].resetFields();
      this.dialogFormVisible = false;
    },
    //删除dialog
    cancelDelete() {
      this.deletedialogVisible = false;
    },
    //删除
    deleteRow(row) {
      this.deletedialogVisible = true;
      this.deleteparams = {
        Id: row.id,
      };
    },
    async confirmDelete() {
      this.deletedialogVisible = false;
      PointsDelete(this.deleteparams)
        .then((res) => {
          if (res.code == 200) {
            this.confirmFlag = true;
            this.confirmMsg = "删除成功";
            this.customSearch();
            this.currentPage1 = 1;
          } else {
            this.confirmFlag = true;
            this.confirmMsg = "删除失败";
          }
        })
        .catch(() => {
          console.log("删除请求失败");
        });
    },
    //搜索button
    async customSearch(int) {
      this.submitLoading = true;
      let searchparams = {
        params: {
          groupId: this.searchForm.groupCode,
          source: this.searchForm.source,
          priceType: this.searchForm.priceType,
          page: int ? int : 1,
          pageSize: 15,
        },
      };
      await getPointsList(searchparams)
        .then((res) => {
          console.log(res);
          this.submitLoading = false;
          this.tableData = res.data.list;
          this.searchForm.total = res.data.total;
        })
        .catch(function (error) {
          this.submitLoading = false;
          console.log("请求失败", error.objError);
        });
    },
    setConfirmFlag(value) {
      this.confirmFlag = value;
    },
    Format(value, index) {
      if (index.property == "createdDate") {
        return formatDateTime(value.createdDate, "YYYY-MM-DD HH:mm:ss");
      } else if (index.property == "isEarnPoints") {
        return value.isEarnPoints ? "可积分" : "不可积分";
      } else if (index.property == "groupid") {
        const group = this.groupList.find((g) => g.code == value.groupid);
        return group ? group.cName : value.groupid;
      } else if (index.property == "priceType") {
        const priceType = this.priceList.find((g) => g.Type == value.priceType);
        return priceType ? priceType.Value : value.priceType;
      }
    },
    uploadFile() {
      this.$confirm(
        "此操作执行的是全量覆盖，将会移除现有设置，使用新的替代",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.importType = "all";
          this.$refs.uploadFile.click();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    uploadFileAdd() {
      this.importType = "add";
      this.$refs.uploadFile.click();
    },
    fileValueChange() {
      this.submitLoading = true;
      // 选中文件后，会触发input的change事件，即会进入此函数
      var formData = new FormData();
      formData.append(
        "file",
        this.$refs.uploadFile.files[0],
        "harp mapping导入文件.xls"
      );
      formData.append("type", this.importType);
      var path = this.$refs.uploadFile.files[0].name; //得到的是现在文件的路径
      var suffix = path.substr(path.lastIndexOf(".")).toUpperCase();
      if (suffix != ".XLS") {
        this.submitLoading = false;
        this.confirmFlag = true;
        this.confirmMsg = "上传失败，请检查是否为XLS文件并重新上传";
        this.$refs.uploadFile.value = "";
        return;
      }
      HotelPointsImport(formData)
        .then((res) => {
          this.submitLoading = false;
          if (res.code == 200) {
            if (res.data.item2.length == 0) {
              this.confirmFlag = true;
              this.confirmMsg = this.$t("MESSAGE.HARPID");
              this.$refs.uploadFile.value = "";
            } else {
              const errorHtml = `<div>导入完成，其余数据已成功导入。失败明细：</div>${res.data.item2
                .map((err) => `<div>${err}</div>`)
                .join("")}`;
              this.$alert(errorHtml, "导入明细", {
                dangerouslyUseHTMLString: true,
                confirmButtonText: "确定",
              });
            }
            this.$refs.uploadFile.value = "";
          }
          //temp
          else if (res.code == 500) {
            this.confirmFlag = true;
            this.confirmMsg = "上传失败，请检查是否为xls文件并重新上传";
            //清空value值  解决无法上传相同名字文件的问题
            this.$refs.uploadFile.value = "";
          }
          this.customSearch();
        })
        .catch((e) => {
          this.submitLoading = false;
          this.confirmFlag = true;
          this.confirmMsg = "上传失败，请检查是否为XLS文件并重新上传";
          this.$refs.uploadFile.value = "";
        });
    },
    async getGroupList() {
      this.submitLoading = true;
      let searchparams = {
        params: {
          page: 1,
          pageSize: 1000,
        },
      };
      await groupList(searchparams)
        .then((res) => {
          this.groupList = res.data.list;
          this.customSearch();
        })
        .catch(function (error) {
          console.log("请求失败", error.objError);
        });
    },
  },
};
</script>

<style scoped>
.paginationsty {
  float: right;
  margin: 1rem 0;
}

.pos_container_panel {
  padding: 0 16rem 4rem;
}

.harpIDbtn {
  width: 12rem;
  height: 4rem;
  padding: 0 !important;
  font-size: 1.2rem !important;
}

.search-fields {
  display: grid;
  grid-template-columns: 24rem 26rem 24rem;
  column-gap: 2rem;
  align-items: center;
  width: max-content;
}

.search-form-item {
  width: 100%;
  margin-right: 0;
  margin-bottom: 1rem;
}

.search-form-item-source {
  width: 24rem;
}

.search-select {
  width: 100%;
}

.search-select-source {
  width: 100%;
}

.search-select-wide {
  width: 100%;
}

.search-form-item :deep(.el-select),
.search-form-item :deep(.el-input),
.search-form-item :deep(.el-input__wrapper) {
  width: 100%;
}
</style>
